import React from "react";
import jwt from 'jwt-decode'
import { validEmailRegex, GOOGLE_AUTH_URL, ACCESS_TOKEN, SIGNIN_AUTH_TOKEN, CAPTCHA_API_KEY, MICROSOFT_AUTH_URL } from '../../settings/shared/constants';
import { validateForm } from '../../settings/shared/commonMethod'
import LoginService from '../../services/api/Login'
import UserService from '../../services/api/User';
import logo from "assets/img/df.png";
import { toast } from 'react-toastify';
// reactstrap components
import {
  Card,
  CardBody,
  CardHeader,
  CardFooter,
  Form,
  Container,
  Col,
  Input,
  InputGroup,
  FormGroup,
  InputGroupAddon,
  InputGroupText,
  Button
} from "reactstrap";

// core components
import Background1 from 'assets/img/1.jpg';
import Background2 from 'assets/img/2.jpg';
import Background3 from 'assets/img/3.jpg';
import Background4 from 'assets/img/4.jpg';
import Background5 from 'assets/img/5.jpg';
import Background6 from 'assets/img/6.png';
import Background7 from 'assets/img/7.png';
import Background8 from 'assets/img/8.png';
import Background9 from 'assets/img/9.png';
import Background10 from 'assets/img/10.png';
import Background11 from 'assets/img/11.png';
import Background12 from 'assets/img/bg14.jpg';
import google from 'assets/img/google.png';
import micro from 'assets/img/micro.png';

import "../../assets/css/custom.css";
import ReCAPTCHA from "react-google-recaptcha";


const styles = {
  error: {
    color: "#ff0000",
    fontSize: 11,
  }
}

class LoginPage extends React.Component {
  constructor(props) {
    super(props);
    let subDomain = window.location.hostname.split('.');
    this.state = {
      formValid: false,
      errorCount: null,
      checked: false,
      subdomain: subDomain[0],
      capchaVerified : false,
      errors: {
        email: '',
        password: '',
        tenant: ''
      },

      images: [
        Background1,
        Background2,
        Background3,
        Background4,
        Background5,
        Background6,
        Background7,
        Background8,
        Background9,
        Background10,
        Background11,
        Background12,
      ],

    };


  }

 // base url
 base_url = () => {
  var pathparts = window.location.pathname.split('/');
  if (window.location.host == 'localhost' && pathparts.length > 1) {
      var url = window.location.origin+'/'+pathparts[1].trim('/')+'/'; // http://localhost/myproject/
  }else{
      var url = window.location.origin; // http://stackoverflow.com
  }
  return url;
}

googleAuthOnClick = (e) => {
  e.preventDefault();
  window.location.href = GOOGLE_AUTH_URL+this.base_url()+"/admin/oauth2/redirect?id=" + this.state.subdomain + "%26isSubdomain=" + process.env.REACT_APP_IS_SUBDOMAIN;
}

microsoftAuthOnClick = (e) =>{
  e.preventDefault();
  window.location.href = MICROSOFT_AUTH_URL+this.base_url()+"/admin/oauth2/redirect?id=" + this.state.subdomain + "%26isSubdomain=" + process.env.REACT_APP_IS_SUBDOMAIN;
}

  // handling event changes email,password
  handleChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    let errors = this.state.errors;

    switch (name) {
      case 'email':
        errors.email =
          validEmailRegex.test(value)
            ? ''
            : 'Email is not valid!';
        break;
      case 'password':
        errors.password =
          value === ""
            ? 'Please enter password'
            : '';
        break;
      case 'tenant':
        errors.tenant =
          value === ""
            ? 'Please enter tenant'
            : '';
        break;
      default:
        break;
    }

    this.setState({ errors, [name]: value });
  }

  onChangeCapcha = () =>{
      this.setState({ capchaVerified: true });
  }

  // signin button click event
  handleSubmit = (event) => {
    event.preventDefault();
    if ((this.state.email === "" || this.state.email === undefined) &&
      (this.state.password === "" || this.state.password === undefined)) {
      toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">Please enter all require fields</b></i>); 
      this.setState({tenantempty:true})
    }
    else if (this.state.email === "" || this.state.email === undefined) {
      toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">Please enter email id</b></i>); 
      this.setState({tenantempty:true})
    }
    else if (this.state.password === "" || this.state.password === undefined) {
      toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">Please enter password</b></i>); 
      this.setState({tenantempty:true})
    }else if(!this.state.capchaVerified){
      toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">Please check the the captcha form</b></i>); 
      this.setState({tenantempty:true})
    }
    else {
        this.setState({tenantempty:false})
        if (validateForm(this.state.errors)) {
          let finalTenat;
          let mySubdomain = window.location.hostname.split('.');
          finalTenat = mySubdomain[0];
          let post = {
            email: this.state.email.toLowerCase(),
            password: this.state.password,
            tenant: finalTenat
          }
          //Login service integration
          LoginService.auth(post)
            .then((response) => {
              var decoded;
              if (response.status === 'SUCCESS') {  
                /* it's having subdomain and previous versions */
                if(process.env.REACT_APP_IS_SUBDOMAIN === "true"){
                  localStorage.setItem(ACCESS_TOKEN, response.token);
                  decoded = jwt(response.token);
                  localStorage.setItem("Uid", decoded.id);
                  this.getUserRole();                  
                } else {
                  /* this block execute if user have multiple tenant list */
                  sessionStorage.setItem(SIGNIN_AUTH_TOKEN, response.authToken);
                  if (response.accountsDTOS !== null) {
                    if (response.accountsDTOS.length > 1) {
                      this.props.history.push({
                        pathname: '/auth/tenants',
                        state: { tenantList: response.accountsDTOS, email: this.state.email }
                      })
                    }else{
                      /* here validate with auth tokan and proceed to landing page */
                      let resposeTenant = response.accountsDTOS[0];
                      localStorage.setItem("accountLogo" ,resposeTenant.accountLogo);
                      localStorage.setItem("accountName" ,resposeTenant.accountName);
                      let tenantData = {
                        email: this.state.email.toLowerCase(),
                        authToken: sessionStorage.getItem(SIGNIN_AUTH_TOKEN),
                        accountId: resposeTenant.accountID
                      }
                      LoginService.auth_tenant(tenantData)
                        .then((response) => {
                          if (response.status === 'SUCCESS') {
                            decoded = jwt(response.token);
                            localStorage.setItem(ACCESS_TOKEN, response.token);
                            localStorage.setItem("Uid", decoded.id);
                            sessionStorage.clear(); // here clear the session storage for auth signin 
                            this.getUserRole();
                          } else if (response.token !== null) {
                            toast.error(response.errorMessage);
                            localStorage.setItem(ACCESS_TOKEN, response.token);
                            decoded = jwt(response.token);
                            localStorage.setItem("Uid", decoded.id);
                            sessionStorage.clear(); // here clear the session storage for auth signin 
                            this.props.history.push('/auth/updatePassword');
                          } else {
                            toast.error(response.errorMessage);
                          }
                        });
                    }
                  }else{
                    toast.error(response.errorMessage);
                  }
                }
              } else if (response.status === "FAILURE") {
                if (response.token !== null) {
                  toast.error(response.errorMessage);
                } else {
                  toast.error(response.errorMessage);
                  localStorage.setItem(ACCESS_TOKEN, response.token);
                  decoded = jwt(response.token);
                  localStorage.setItem("Uid", decoded.id);
                  this.props.history.push('/auth/updatePassword');
                }
              } else {
                toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
                this.clearformData();   // Reset Form data    
              }
            });
        } else {
          console.error('Invalid Form')
        }
      // }
     }
  }
  // Clear form data after form submit
  clearformData() {
    this.setState({
      checked: false,
      email: "",
      password: ""
    })
  }


  getUserRole = () => {
    UserService.getuserRole(localStorage.getItem('Uid'))
      .then((response) => {
        if (response.status === 'SUCCESS') {
          if (response.userDTOS.length > 0) {
            localStorage.setItem("lastLogin", response.userDTOS[0].lastLogin);
            localStorage.setItem("role", response.userDTOS[0].role);
            this.props.history.push('/auth/menu-settings');
            this.clearformData();   // Reset Form data 
          }
        } else {
          toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>);
        }

      });
  }

  componentDidMount() {
    let tenanttok = window.location.hostname;
    
    // this.setState({ subdomain: 'subDomain[0]' })
    document.body.classList.add("login-page");

    document.body.style.backgroundImage = `url(${this.state.selectedImage})`;
    var background = this.state.images[Math.floor(Math.random() * this.state.images.length)];
    this.state.selectedImage = background;

    document.body.classList.add("bgdefault");
    document.body.style.backgroundImage = `url(${this.state.selectedImage})`;
    document.body.style.backgroundPosition = 'center';
    document.body.style.backgroundSize = 'cover';
    document.body.style.backgroundRepeat = 'no-repeat';

    var spans = document.getElementsByClassName('full-page section-image');
    var i;
    for(i=0; i<spans.length; i++) {
        spans[i].classList.remove("df-bg-white");
    }

    if (localStorage.getItem(ACCESS_TOKEN) !== null) {
      this.props.history.push('/auth/menu-settings');
    }

    if (this.props.location.state !== undefined) {
      if(this.props.location.state.msg !== ""){
        toast.error(this.props.location.state.msg, {autoClose:5000})
        this.props.history.push({
          pathname: '/auth/login-page',
          state: { msg: '' }
        })
      }
    }

  }
  render() {
    const { errors } = this.state;

    return (
      <>
        <div className="content">
          <div className="login-page login-box-top">
            <Container>

              {/* <ToastContainer /> */}
              <Col xs={12} md={8} lg={5} className="ml-auto mr-auto">
                {/* <Form> */}
                <Card className="card-login card-plain">
                  <div className="text-center">
                    <img src={logo} alt="decisionforce" href="https://decisionfacts.ai/" className="text-center" style={{ width: '60px', height: '60px', cursor: 'pointer' }}></img>
                  </div>
                  <CardHeader>
                    <h6 className="text-center headtext">Sign in with credentials</h6>
                  </CardHeader>
                  <CardBody>
                    <div className="">
                      <Form role="form" onSubmit={this.handleSubmit} noValidate>
                          <InputGroup
                            className={
                              "no-border form-control-lg " +
                              (this.state.email ? "input-group-focus" : "")
                            }
                          >
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText>
                                <i className="now-ui-icons ui-1_email-85" />
                              </InputGroupText>
                            </InputGroupAddon>
                            <Input placeholder="Email" type="email" name="email" value={this.state.email || ""} onChange={this.handleChange} noValidate />

                            {/* <Input
                          placeholder="User Name"
                          type="email" name="email" 
                          value={this.state.email} onChange={this.handleChange} noValidate
                         /> */}
                          </InputGroup>
                          {errors.email.length > 0 &&
                            <span style={styles.error}>{errors.email}</span>}

                          <InputGroup
                            className={
                              "no-border form-control-lg " +
                              (this.state.password ? "input-group-focus" : "")
                            }
                          >
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText>
                                <i className="now-ui-icons text_caps-small" />
                              </InputGroupText>
                            </InputGroupAddon>
                            <Input
                              type="password" value={this.state.password || ""}
                              name="password" onChange={this.handleChange} noValidate
                              placeholder="Password"
                            />
                          </InputGroup>
                          {errors.password.length > 0 &&
                            <span style={styles.error}>{errors.password}</span>}
                        <ReCAPTCHA
                          className="g-recaptchaWidth"
                          sitekey={CAPTCHA_API_KEY}
                            onChange={this.onChangeCapcha}
                        />
                        <Button
                          block
                          color="primary"
                          size="lg"
                          className="mb-3"
                          type="submit"
                        >
                          Sign In
                      </Button>
                        <div className="pull-left">
                          <h6>
                            <a href="/auth/forgotpassword" className="link footer-link">
                              Forgot Password ?
                          </a>
                          </h6>
                        </div>


                      </Form>
                    </div>
                  </CardBody>
                  <CardFooter>
                    <br></br>
                    <p className="category text-center"><b>Or</b></p>
                    <div className="btns-mr-5 text-center" >

                      <Button className="mr-2 df-btn-light" onClick={this.googleAuthOnClick} >
                        <img src={google} width={20}className="mr-1"/> Google
                      </Button>

                      <Button className="df-btn-light" onClick={this.microsoftAuthOnClick}>
                        <img src={micro} width={20} color="google" className="mr-1" /> Microsoft
                      </Button>


                    </div>
                  </CardFooter>

                </Card>
                {/* </Form> */}
              </Col>
            </Container>
          </div>
        </div>

        <div
          className="full-page-background bgdefault"
        // style={{ backgroundImage: "url(" + bgImage + ")" }}
        />
      </>
    );
  }
}

export default LoginPage;
